import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAuthDetail} from '../services/getAuthDetail';

export const useGetAuthDetail = (nuControle: number, enabled = true) =>
	useQuery({
		queryKey: [QUERY_KEYS.AUTOSOL_REQUEST_DETAILS, nuControle],
		queryFn: ({signal}) => getAuthDetail(nuControle, signal),
		enabled: !!nuControle && enabled,
	});
